<!-- User rounded button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
  @if (user.photoProfileId?.value) {
    <img
      class="object-cover rounded-full shrink-0 !w-7 !h-7"
      alt="avatar image"
      [src]="avatarImgUrl"
    />
  }

  @if (!user.photoProfileId?.value) {
    <div class="w-7 h-7 rounded-full text-[10px] bg-primary flex justify-center items-center">
      {{ avatarFirstName.charAt(0) + avatarLastName.charAt(0) }}
    </div>
  }
</button>

<!-- Button menu -->
<mat-menu [xPosition]="'before'" #userActions="matMenu">
  <!-- Representante legal -->
  @if (user?.userType === 'entity') {
    <button mat-menu-item>
      <span class="flex flex-col leading-none">
        <span>Representante legal</span>
        <span class="mt-1.5 text-md font-medium">
          {{ user?.manager?.firstname }} {{ user?.manager?.surname }}
        </span>
      </span>
    </button>
  }

  @if (user?.userType === 'entity') {
    <mat-divider class="my-2"></mat-divider>
  }

  <!-- Orden de 062-documentos (FR-002): Mi cuenta, Documentos, Invertir como sociedad,
    BetterplanUS, Balance General y Preguntas frecuentes, cada una con su condición de hoy. -->

  <!-- Mi cuenta - Active -->
  @if (canGotoMiPerfil) {
    <button mat-menu-item [routerLink]="['/profile']">
      <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
      <span>Mi cuenta</span>
    </button>
  }

  <!-- Mi cuenta - Disabled -->
  @if (!canGotoMiPerfil) {
    <div
      matTooltip="Podrás acceder a tu cuenta una vez que hayas completado el Paso 3"
      matTooltipPosition="right"
      #miPerfilTooltip="matTooltip"
      (click)="miPerfilTooltip.toggle()"
    >
      <button mat-menu-item disabled>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Mi cuenta</span>
      </button>
    </div>
  }

  <!-- Documentos: misma condición que Mi cuenta (FR-005) -->
  @if (canGotoMiPerfil) {
    <button mat-menu-item [routerLink]="['/documents']">
      <mat-icon [svgIcon]="'heroicons_outline:folder-open'"></mat-icon>
      <span>Documentos</span>
    </button>
  } @else {
    <div
      matTooltip="Podrás acceder a tus documentos una vez que hayas completado el Paso 3"
      matTooltipPosition="right"
      #documentsTooltip="matTooltip"
      (click)="documentsTooltip.toggle()"
    >
      <button mat-menu-item disabled>
        <mat-icon [svgIcon]="'heroicons_outline:folder-open'"></mat-icon>
        <span>Documentos</span>
      </button>
    </div>
  }

  @if (user?.userType !== 'entity') {
    <!-- Invertir como sociedad -->
    <button mat-menu-item [routerLink]="['/entity/activate']">
      <mat-icon [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
      <span>Invertir como sociedad</span>
    </button>
  }

  <!-- BetterplanUS: la condición que tenía el menú lateral (FR-002) -->
  @if (showBetterplanUs()) {
    <button mat-menu-item [routerLink]="[betterplanUsLink]">
      <mat-icon [svgIcon]="'heroicons_outline:flag'"></mat-icon>
      <span>BetterplanUS</span>
    </button>
  }

  <!-- Balance general -->
  <button mat-menu-item (click)="onClickGeneralBalance()">
    <mat-icon [svgIcon]="'heroicons_outline:chart-bar-square'"></mat-icon>
    <span>Balance General</span>
  </button>

  <!-- Preguntas frecuentes -->
  <button mat-menu-item>
    <a
      href="https://intercom.help/betterplan-advisors/es"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center"
    >
      <mat-icon [svgIcon]="'mat_outline:help_outline'"></mat-icon>
      <span>Preguntas frecuentes</span>
    </a>
  </button>

  <!-- Mostrar valores del debug -->
  @if (isDebugMode) {
    <button mat-menu-item (click)="showDebugPage()">
      <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
      <span>Mostrar valores del debug</span>
    </button>
  }

  <!-- Cambiar de usuario -->
  @if (isAdminUser || canChangeUser) {
    <button mat-menu-item [routerLink]="['/companies']">
      <mat-icon [svgIcon]="'mat_solid:people_outline'"></mat-icon>
      <span>Cambiar de usuario</span>
    </button>
  }

  <mat-divider class="my-2"></mat-divider>

  <!-- Cerrar sesión -->
  <button mat-menu-item (click)="onLogout()">
    <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
    <span>Cerrar sesión</span>
  </button>
</mat-menu>
